






































































import {Component, Vue} from "vue-property-decorator";
import CoverSection from "@/sections/CoverSection.vue";
import ContentSection from "@/sections/ContentSection.vue";

@Component({
    components: {CoverSection, ContentSection}
})
export default class About extends Vue {
}
